import logoImg from "images/headerLogo.svg";

export default function Logo() {
  return <img className="sm:h-10 sm:w-40 w-24 h-6" src={logoImg} alt="torc" />;
}
